import { Link } from "react-router-dom";
import { Instagram, Facebook, Mail, Phone, MapPin, Clock } from "lucide-react";

const DIVISIONS = [
  { to: "/shop", label: "Shop All Products" },
  { to: "/shop", label: "Custom Apparel" },
  { to: "/shop", label: "Tumblers & Drinkware" },
  { to: "/shop/studio", label: "Custom Order Studio" },
];
const QUICK = [
  { to: "/", label: "Home" },
  { to: "/shop", label: "Shop" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
  { to: "/account", label: "My Account" },
];

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-black text-chrome/70 border-t border-electric/15" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 py-16 grid gap-12 md:grid-cols-2 lg:grid-cols-4">
        {/* Brand & Mission */}
        <div>
          <div className="flex items-center gap-3">
            <span className="relative inline-flex items-baseline metal-text font-serif leading-none drop-shadow-[0_0_10px_rgba(0,140,255,0.25)]" aria-hidden="true">
              <span className="text-4xl">C</span><span className="text-4xl -ml-2.5">C</span>
            </span>
            <span className="font-serif text-white text-xl leading-tight">Collins Crafty<br /><span className="text-chrome/60 text-[10px] tracking-[0.3em]">CREATIONS</span></span>
          </div>
          <div className="font-script text-2xl blue-text mt-4">Handmade with heart.</div>
          <p className="text-sm mt-3 leading-relaxed text-chrome/55">
            Custom apparel, tumblers, personalized gifts & bespoke printing — handcrafted in Memphis for every occasion.
          </p>
          <div className="flex items-center gap-3 mt-5">
            <a href="#" aria-label="Facebook" data-testid="footer-facebook" className="w-9 h-9 rounded-full border border-white/15 flex items-center justify-center hover:border-electric hover:text-electric transition-colors"><Facebook size={15} /></a>
            <a href="#" aria-label="Instagram" data-testid="footer-instagram" className="w-9 h-9 rounded-full border border-white/15 flex items-center justify-center hover:border-electric hover:text-electric transition-colors"><Instagram size={15} /></a>
            <a href="mailto:hello@collinscrafty.co" aria-label="Email" data-testid="footer-email" className="w-9 h-9 rounded-full border border-white/15 flex items-center justify-center hover:border-electric hover:text-electric transition-colors"><Mail size={15} /></a>
          </div>
        </div>

        {/* Shop */}
        <div>
          <h4 className="font-serif text-white text-lg">Shop</h4>
          <span className="block h-px w-10 bg-electric mt-3 mb-4 shadow-[0_0_8px_rgba(0,140,255,0.6)]" />
          <ul className="space-y-2.5 text-sm">
            {DIVISIONS.map((d) => (
              <li key={d.to}><Link to={d.to} className="hover:text-electric transition-colors" data-testid={`footer-div-${d.to}`}>{d.label}</Link></li>
            ))}
          </ul>
        </div>

        {/* Quick Links */}
        <div>
          <h4 className="font-serif text-white text-lg">Quick Links</h4>
          <span className="block h-px w-10 bg-electric mt-3 mb-4 shadow-[0_0_8px_rgba(0,140,255,0.6)]" />
          <ul className="space-y-2.5 text-sm">
            {QUICK.map((q) => (
              <li key={q.to}><Link to={q.to} className="hover:text-electric transition-colors" data-testid={`footer-link-${q.to}`}>{q.label}</Link></li>
            ))}
          </ul>
        </div>

        {/* Contact & Hours */}
        <div>
          <h4 className="font-serif text-white text-lg">Contact &amp; Hours</h4>
          <span className="block h-px w-10 bg-electric mt-3 mb-4 shadow-[0_0_8px_rgba(0,140,255,0.6)]" />
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-2.5"><MapPin size={15} className="text-electric mt-0.5 shrink-0" /> Memphis &amp; Surrounding Areas, TN</li>
            <li className="flex items-center gap-2.5"><Mail size={15} className="text-electric shrink-0" /> <a href="mailto:hello@collinscrafty.co" className="hover:text-electric transition-colors">hello@collinscrafty.co</a></li>
            <li className="flex items-center gap-2.5"><Phone size={15} className="text-electric shrink-0" /> <a href="tel:+19015550100" className="hover:text-electric transition-colors">(901) 555-0100</a></li>
            <li className="flex items-start gap-2.5"><Clock size={15} className="text-electric mt-0.5 shrink-0" /> Mon–Sat, 9:00 AM – 6:00 PM CT</li>
          </ul>
        </div>
      </div>

      {/* Compliance strip */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 py-6 text-[11px] leading-relaxed text-chrome/40 space-y-1">
          <p>All products are handmade to order; slight variations are part of the handcrafted charm. Custom orders require approval and payment before production begins.</p>
          <p>Design fees may apply to custom artwork and will be communicated before any work begins. Turnaround times vary by product and order volume.</p>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-chrome/50">
          <div>© {year} Collins Crafty Creations. All rights reserved.</div>
          <div className="flex items-center gap-3">
            <Link to="/privacy" className="hover:text-electric transition-colors">Privacy Policy</Link>
            <span className="text-white/20">|</span>
            <Link to="/terms" className="hover:text-electric transition-colors">Terms of Service</Link>
            <span className="text-white/20">|</span>
            <Link to="/admin" className="text-chrome/30 hover:text-electric transition-colors" data-testid="footer-admin">Admin Portal</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
